import api from "./index";

export const getReportFilterYearsService = async ({ token, active } = {}) => {
  return await api.get("/admin/report-filters/years", {
    params: active === undefined || active === null ? {} : { active },
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getReportFilterEventsByYearService = async ({
  token,
  year,
  active,
} = {}) => {
  return await api.get("/admin/report-filters/events", {
    params: {
      year,
      ...(active === undefined || active === null ? {} : { active }),
    },
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      Authorization: `Bearer ${token}`,
    },
  });
};
